import { Cloud$MainHardwareType } from '@otovo/shared/types/cloudEnums';
import { Sanity$HeroSection } from '@otovo/shared/types/sanityTypes';
import cx from 'classnames';
import { stegaClean } from 'next-sanity';
import Banner from './Banner';
import CampaignContent from './CampaignContent';
import DefaultContent from './DefaultContent';
import HeroImage from './HeroImage';

type Props = {
  heroSection: Sanity$HeroSection;
  mainHardwareType?: Cloud$MainHardwareType;
};

const GradientOverlay = ({ type }: { type: Sanity$HeroSection['type'] }) => {
  const className = 'absolute inset-0 z-10';
  if (type === 'campaign') {
    return (
      <div
        className={cx(
          'bg-[rgba(27,36,56,0.2)] sm:bg-[linear-gradient(270deg,rgba(27,36,56,0)_0%,rgba(27,36,56,0.6)_34.13%,rgba(27,36,56,0.92)_50.96%,#1B2438_69.71%)]',
          className,
        )}
      />
    );
  }
  return (
    <div
      className={cx(
        'bg-[linear-gradient(rgba(13,18,28,0.05)_34.58%,rgba(13,18,28,0.6)_57.08%,rgba(13,18,28,0.8)_69.71%)] sm:bg-[linear-gradient(270deg,rgba(248,248,252,0)_13.89%,rgba(16,25,50,0.45)_50%,rgba(13,18,28,0.7)_100%)]',
        className,
      )}
    />
  );
};

const HeroSection = ({
  heroSection,
  mainHardwareType = 'pv_system',
}: Props) => {
  const image = heroSection.mainImage;
  const { banner } = heroSection;

  const type = stegaClean(heroSection.type);

  const renderContent = () => {
    if (type === 'campaign') {
      return (
        <CampaignContent
          heroSection={heroSection}
          mainHardwareType={mainHardwareType}
        />
      );
    }
    return (
      <DefaultContent
        heroSection={heroSection}
        mainHardwareType={mainHardwareType}
      />
    );
  };

  const showBanner = banner?.content || banner?.cta;

  return (
    <header
      id="heroSection"
      className="color-scheme-dark relative flex min-h-screen w-full items-end sm:pr-24 md:py-24 md:pr-0 lg:py-32 2xl:min-h-[80vh]"
    >
      {showBanner && <Banner banner={banner} variant={type} />}
      <div className="isolate">
        {image?.asset && <HeroImage image={image} />}
        <GradientOverlay type={type} />
      </div>

      {renderContent()}
    </header>
  );
};

export default HeroSection;
